const FormHidden = ({ children, actionPost, portalValue, typeLogon }) => {
  return (
    <div className="ds-header__form-hidden">
      <form id="login-form" method="post" action={actionPost}>
        {children}
        <input type="hidden" name="portal" value={portalValue} />
        <input type="hidden" name="pre-login" value="pre-login" />
        <input type="hidden" name="destino" value="" />
        <input type="hidden" name="tipoLogon" value={typeLogon} />
        <button type="submit" id="submitformLogin"></button>
      </form>
    </div>
  )
}

export default FormHidden
